export default "__VITE_ASSET__DYKe2xbg__"